window.mapUtils = window.mapUtils || {};
window.mapUtils.maps = {};

/**
 * Initializes a Leaflet map at the specified coordinates and zoom level.
 * This function only initializes the map and doesn't add any markers.
 * 
 * @function initializeLeafletMap
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the HTML element to attach the map to.
 * @param {number} latitude - The latitude for the map's center.
 * @param {number} longitude - The longitude for the map's center.
 * @param {number} zoom - The zoom level of the map.
 */
window.mapUtils.initializeLeafletMapWithPin = function (mapId, latitude, longitude, zoom, label) {
    const map = L.map(mapId, {
        center: [latitude, longitude],
        zoomControl: false,
        scrollWheelZoom: false,
        doubleClickZoom: false,
        dragging: false
    }).setView([latitude, longitude], zoom);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' }).addTo(map);

    window.mapUtils.maps[mapId] = map;
    window.mapUtils.addPin(mapId, latitude, longitude, 'green', label);
};

/**
 * Initializes a Leaflet map at the specified coordinates and zoom level.
 * This function only initializes the map and doesn't add any markers.
 * 
 * @function initializeLeafletMap
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the HTML element to attach the map to.
 * @param {number} latitude - The latitude for the map's center.
 * @param {number} longitude - The longitude for the map's center.
 * @param {number} zoom - The zoom level of the map.
 */
window.mapUtils.initializeLeafletMap = function (mapId) {
    const map = L.map(mapId, {
        center: [54.5593, -2.5879],
        zoomControl: false,
        scrollWheelZoom: false,
        doubleClickZoom: false,
        dragging: false
    }).setView([54.5593, -2.5879], 5);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    window.mapUtils.maps[mapId] = map;
};

/**
 * Adds a pin to the map with a specified color and optional label.
 * 
 * @function addPin
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the map container element.
 * @param {number} latitude - The latitude for the marker location.
 * @param {number} longitude - The longitude for the marker location.
 * @param {string} color - The color of the marker icon (e.g., 'red', 'green', 'blue').
 * @param {string} [label] - (Optional) The label text to display when hovering over the marker.
 */
window.mapUtils.addPin = function (mapId, latitude, longitude, color, label) {
    const map = window.mapUtils.maps[mapId];

    if (!map) {
        console.error(`Map with ID ${mapId} not found!`);
        return;
    }

    const customIcon = L.icon({
        iconUrl: `/images/maps/pin-${color}.png`,
        iconSize: [25, 41],    // Size of the pin icon
        iconAnchor: [12, 41],  // Anchor the bottom of the pin at the correct position
        popupAnchor: [0, -41]  // Align the popup directly above the pin
    });

    var marker = L.marker([latitude, longitude], { icon: customIcon }).addTo(map);

    if (label) {
        marker.bindTooltip(label, {
            permanent: true,
            direction: 'top', // Tooltip will appear above the marker
            offset: [0, -45], // Adjust the offset to place the label properly above the marker
            className: 'leaflet-tooltip'
        }).openTooltip();
    }

    return marker;
};

/**
 * Removes a map pin from the map.
 * 
 * @function removePin
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the map container element.
 * @param {object} marker - The Leaflet marker object to remove.
 */
window.mapUtils.removePin = function (mapId, marker) {
    const map = window.mapUtils.maps[mapId];

    if (!map) {
        console.error(`Map with ID ${mapId} not found!`);
        return;
    }

    map.removeLayer(marker);
};

/**
 * Zooms the map to a specified zoom level.
 * 
 * @function zoomMap
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the map container element.
 * @param {number} zoomLevel - The zoom level to set on the map.
 */
window.mapUtils.zoomMap = function (mapId, zoomLevel) {
    const map = window.mapUtils.maps[mapId]; // Retrieve the map object by mapId

    if (!map) {
        console.error(`Map with ID ${mapId} not found!`);
        return;
    }

    map.setZoom(zoomLevel);
};

/**
 * Pans the map to a specified latitude and longitude.
 * 
 * @function goToLocation
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the map container element.
 * @param {number} latitude - The latitude to pan to.
 * @param {number} longitude - The longitude to pan to.
 */
window.mapUtils.goToLocation = function (mapId, latitude, longitude) {
    const map = window.mapUtils.maps[mapId]; // Retrieve the map object by mapId

    if (!map) {
        console.error(`Map with ID ${mapId} not found!`);
        return;
    }

    map.setView([latitude, longitude], map.getZoom());
};

/**
 * Smoothly flies the map to a specified latitude and longitude.
 * 
 * @function flyToLocation
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the map container element.
 * @param {number} latitude - The latitude to fly to.
 * @param {number} longitude - The longitude to fly to.
 */
window.mapUtils.flyToLocation = function (mapId, latitude, longitude) {
    const map = window.mapUtils.maps[mapId];

    if (!map) {
        console.error(`Map with ID ${mapId} not found!`);
        return;
    }

    map.flyTo([latitude, longitude], map.getZoom());
};
